<span *ngIf="alert">
  <div class="sd_alert_info" *ngIf="alert.type==='info'">
    <span class="sd_alert_text" #sdAlertText>
      {{alert.message | translate: {value: alert.params} }} 
      {{alert.status}}
      <a class="sd_alert_close" (click)="deleteAlert()" >&times;</a>   
    </span>
  </div>
  <div class="sd_alert_warn" *ngIf="alert.type==='warn'">
    <span class="sd_alert_text" #sdAlertText>
      {{alert.message | translate: {value: alert.params} }} 
      {{alert.status}}
      <a class="sd_alert_close" (click)="deleteAlert()" >&times;</a>   
    </span>
  </div>
</span>